module.exports = "/packs/media/modules/welcome/welcome/faq/assets/feature-b9960a19ba8e1a5a35722255e3bd7e9c.png";